import { render, staticRenderFns } from "./MenuSlowniki.vue?vue&type=template&id=44e5a7ba&scoped=true&"
import script from "./MenuSlowniki.vue?vue&type=script&lang=js&"
export * from "./MenuSlowniki.vue?vue&type=script&lang=js&"
import style0 from "./MenuSlowniki.vue?vue&type=style&index=0&id=44e5a7ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e5a7ba",
  null
  
)

export default component.exports